const server = {
    token: process.env.VUE_APP_SERVER_TOKEN,
    host: process.env.VUE_APP_SERVER_HOST,
    username: process.env.VUE_APP_SERVER_USERNAME,
    password: process.env.VUE_APP_SERVER_PASSWORD,
    receiver: process.env.VUE_APP_SERVER_RECEIVER,
}

export default server;